import type { Event } from '@patsnap/tahiti-core/common/event';

import type { SpecificationConfirmClaimsData, SpecificationConfirmClaimsState } from '../types/specification-confirm-claims';

export const SpecificationConfirmClaimsService = Symbol.for('SpecificationConfirmClaimsService');

export interface SpecificationConfirmClaimsService {
    readonly onStateChange: Event<SpecificationConfirmClaimsState>;

    /**
     * 初始化, 如果内部状态已准备好, 则直接返回
     * @param taskId 任务ID
     */
    init(taskId: string, regenerate?: boolean): Promise<void>;

    /** 获取状态 */
    getState(): SpecificationConfirmClaimsState;

    /** 设置表单数据 */
    patchFormData(payload: Partial<SpecificationConfirmClaimsData>): void;

    /** 返回前一步 */
    previous(): Promise<void>;

    /**
     * 提交
     * !!! 默认会切换到下一个步骤
     */
    submit(switchStep?: boolean): Promise<void>;

    /**
     * 重新生成
     * 需要先 cancel 当前任务
     * 然后重新初始化
     */
    regenerate(): Promise<void>;
}
